import React from 'react';
import { withRouter } from 'react-router-dom';
import Header from 'components/Header';
import { Form, Icon } from 'semantic-ui-react';
import CancelGoButtons from 'components/CancelGoButtons';
import API from 'utils/api';

class MenuProductDescriptionForm extends React.Component {
  constructor(props) {
    super(props);
    
    this.state = {
      valid: false,
      loading: true,
      error: null,
      product: null,
      productId: null,
      description: ''
    };

    this.descriptionInputRef = React.createRef();
  }

  componentDidMount() {
    const productId = parseInt(this.props.match.params.productId);
    this.setState({ productId }, this.loadProduct);
  }

  componentDidUpdate(prevProps, prevState) {
    // Focus the description input when loading is done
    if (prevState.loading && !this.state.loading) {
      if (this.descriptionInputRef.current) {
        this.descriptionInputRef.current.focus();
      }
    }
  }
  
  loadProduct = () => {
    API.getProduct(this.state.productId)
      .then((response) => {
        this.setState({ 
          product: response.data,
          loading: false,
          // Initialize description if it exists
          description: response.data.desc || ''
        }, this.validate);
      })
      .catch((error) => {
        console.error(error);
        this.setState({ 
          error: 'Error al cargar el producto',
          loading: false
        });
      });
  }

  handleDescription = (event) => {
    this.setState({ description: event.target.value }, this.validate);
  }
  
  validate = () => {
    // Description is optional but can't be just whitespace
    let valid = true;
    if (this.state.description.trim() === '') {
      valid = false;
    }
    this.setState({ valid });
  }

  updateProductDescription = () => {
    if (this.state.valid) {
      this.setState({ loading: true, error: null });
      
      const params = {
        desc: this.state.description
      };

      API.updateProductDescription(this.state.productId, params)
        .then((response) => {
          // Go back to the product page
          this.props.history.push(`/menu/products/${this.state.productId}`);
        })
        .catch((error) => {
          console.error(error);
          this.setState({ 
            error: 'Error al actualizar la descripción del producto',
            loading: false
          });
        });
    }
  }

  render() {
    const formTitle = this.state.product ? `Editar ${this.state.product.name}` : 'Agregar descripción';
    
    if (this.state.loading) {
      return (
        <div>
          <Header text={formTitle} />
          <div style={{ textAlign: 'center', padding: '2em' }}>
            <Icon loading name='spinner' size='large' />
            <p style={{ marginTop: '1em', color: '#666' }}>Cargando producto...</p>
          </div>
        </div>
      );
    }
    
    if (!this.state.product) {
      return (
        <div>
          <Header text="Error" />
          <div style={{ 
            color: '#db2828', 
            margin: '1.5em 0', 
            padding: '12px', 
            backgroundColor: '#fff6f6', 
            borderRadius: '4px',
            fontSize: '1.1em'
          }}>
            No se encontró el producto
          </div>
          <div style={{ marginTop: '2em' }}>
            <CancelGoButtons 
              cancelFn={() => this.props.history.push('/menu/products')}
              cancelText="regresar"
              hideGoButton={true}
              style={{
                button: {
                  height: '54px',
                  fontSize: '1.1em',
                  fontWeight: 'bold',
                  boxShadow: 'none',
                  borderRadius: '8px'
                }
              }}
            />
          </div>
        </div>
      );
    }
    
    return (
      <div>
        <Header text={formTitle} subtitle={this.state.product.name} />
        
        {this.state.error && (
          <div style={{ 
            color: '#db2828', 
            margin: '1.5em 0', 
            padding: '12px', 
            backgroundColor: '#fff6f6', 
            borderRadius: '4px',
            fontSize: '1.1em'
          }}>
            {this.state.error}
          </div>
        )}
        
        <Form as="div" style={{ marginTop: '1.5em' }}>
          <Form.Field style={{ marginBottom: '1.5em' }}>
            <label style={{ fontSize: '1.1em', color: '#666', marginBottom: '8px', display: 'block' }}>
              DESCRIPCIÓN
            </label>
            <textarea
              ref={this.descriptionInputRef}
              placeholder='Descripción del producto'
              onChange={this.handleDescription}
              value={this.state.description}
              style={{ 
                fontSize: '1.2em',
                padding: '12px',
                minHeight: '150px',
                width: '100%',
                borderRadius: '4px',
                border: '1px solid rgba(34,36,38,.15)'
              }}
            />
          </Form.Field>
          
          <CancelGoButtons
            cancelFn={() => this.props.history.push(`/menu/products/${this.state.productId}`)}
            cancelText="cancelar"
            goText="guardar"
            goFn={this.updateProductDescription}
            goEnabled={this.state.valid && !this.state.loading}
            loading={this.state.loading}
            style={{
              button: {
                height: '54px',
                fontSize: '1.1em',
                fontWeight: 'bold',
                boxShadow: 'none',
                borderRadius: '8px'
              }
            }}
          />
        </Form>
      </div>
    );
  }
}

export default withRouter(MenuProductDescriptionForm); 